<!--
 * @Author: 张天昊
 * @Date: 2024-05-29 15:12:34
 * @LastEditTime: 2024-09-26 16:44:01
 * @LastEditors: Please set LastEditors
 * @Description: 底部操作栏
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/OperationBar.vue
-->
<script>
import { computed, defineComponent, watch } from 'vue';
import { Dialog, Toast } from 'vant';
import qs from 'qs';
import { useAuth } from '../composables/useAuth';
import { useFixedElementHeight } from '@/composables/useFixedElementHeight';
import store from '@/store';
import router from '@/router/routers';
import { useRouter } from 'vue-router/composables'


export default defineComponent({
  setup() {
    const route = router.currentRoute;
    const {
      showGuideToggleTourGroupBtn,
      showScenicModifyBtn,
      showItineraryModifyBtn,
      showAgencyAuditBtn
    } = useAuth();
    const show = computed(() =>
      [
        showGuideToggleTourGroupBtn.value,
        showScenicModifyBtn.value,
        showItineraryModifyBtn.value,
        showAgencyAuditBtn.value
      ].some((i) => i)
    );
    const { el, height, updateHeight } = useFixedElementHeight();
    watch(
      () => [
        showGuideToggleTourGroupBtn.value,
        showScenicModifyBtn.value,
        showItineraryModifyBtn.value,
        showAgencyAuditBtn.value
      ],
      () => {
        updateHeight();
      }
    );
    const btnSharedProps = {
      color: '#36B374',
      class: 'custom-btn'
    };
    // 带团操作
    async function toggleTourGroup(state) {
      const message = state
        ? '确认接受带团任务？接受后不可反悔撤销，请务必确保您能如期带团。'
        : '确定要放弃本次带团？如果本次拒绝任务，无法撤销哦，请谨慎思考后操作。';
      try {
        await Dialog.confirm({
          message,
          confirmButtonColor: '#36B374'
        });

        const res = await store.dispatch('itineraryUniversal/toggleTourGroup', {
          id: route.params.id,
          state
        });
        res && Toast.success(`已成功${state ? '带团' : '拒绝'}`);
      } catch (e) {
        console.log('取消');
      }
    }

    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );

    // 旅行社审核 
    async function auditTourGroup() {
      Dialog.confirm({
        message: '确认行程单审核通过',
        confirmButtonColor: '#36B374'
      }).then(async () => {
        try {
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
          });
          const res = await store.dispatch('itineraryUniversal/agencyRoleAuditTourGroup', {
            id: detailInfo.value.itineraryInfoMessage.id,
          });
          res && Toast.success(`已成功`);
        } catch (e) {
          Toast.fail(`接口失败`);
        }
      }).catch(() => {
        // on cancel

      });


    }
    /**
     * 变更操作是耦合的
     * 只能跳转到老行程单详情再重新触发操作
     */
    function onExternalLink(role) {
      const id = route.params.id;
      const query = qs.stringify(route.query);
      window.yyn.invokeJSB('openWindow', {
        openUrl: `${window.location.origin}/team-supervision/itinerary-app/index.html#/itinerary_app/message/${id}?role=${role}&${query}`,
        hiddenTitleBar: true,
        needLoading: 1
      });
    }

    
    const navigate = useRouter()
    /**
     * 行程变更
     */
    function onChangeTravel(){
      navigate.push({name:'itineraryUniversalDetailChangeTravel'})
    }

    return {
      show,
      el,
      height,
      btnSharedProps,
      showGuideToggleTourGroupBtn,
      showScenicModifyBtn,
      showItineraryModifyBtn,
      toggleTourGroup,
      onExternalLink,
      showAgencyAuditBtn,
      auditTourGroup,
      onChangeTravel
    };
  }
});
</script>

<template>
  <div v-if="show" :style="{ paddingTop: height }">

    <div ref="el" class="fixed z-10 bottom-0 left-0 right-0">
      <div class="pt-8 px-16 safe-area-inset-bottom-footer flex justify-end bg-white">
        <template v-if="showGuideToggleTourGroupBtn">
          <van-button v-bind="btnSharedProps" plain @click="toggleTourGroup(false)">拒绝带团</van-button>
          <van-button v-bind="btnSharedProps" @click="toggleTourGroup(true)">确认带团</van-button>
        </template>
        <!-- <van-button v-if="showScenicModifyBtn" v-bind="btnSharedProps" plain
          @click="onExternalLink('guide')">登记景区变更</van-button> -->
        <!-- <van-button v-if="showItineraryModifyBtn" v-bind="btnSharedProps" plain
          @click="onExternalLink('travelAgency')">登记行程变更</van-button> -->
        <van-button v-if="showItineraryModifyBtn" v-bind="btnSharedProps" plain
          @click="onChangeTravel">登记行程变更</van-button>
        <template v-if="showAgencyAuditBtn">
          <van-button v-bind="btnSharedProps" plain @click="auditTourGroup">行程单审核</van-button>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-btn.van-button {
  height: 48px;
  font-size: 18px;
}

.custom-btn.van-button:not(:first-child) {
  margin-left: 7px;
}
</style>
